export const AddressProofTemplate = {
    name: 'address_proof',
    label: 'Address Proof',
    subject: "Rebit verification: Address Proof",
    category: 'compulsory',
    body: "<p>Hi, ${name}!</p>"
        + "<p>Thanks for your time starting the verification process! We have reviewed the result of your verification check. Here’s what we need to enable your profile:</p>"
        + "<p><b>We need a form of Address Proof</b></p>"
        + "<p>Your address: ${shorted_address}</p>"
        + "<p>Some of the accepted documents are:</p>"
        + "<ul>"
        + "<li>Bank Statement or Proof of Account showing your name and address. Download them from your bank website.</li>"
        + "<li>Power, Internet, or any utility bills with your name and address.</li>"
        + "<li>Rental agreement</li>"
        + "</ul>"
        + "<p><b>How to send it</b></p>"
        + "<ul>"
        + "<li>Login to your Rebit account and go to:<br>ACCOUNT > VERIFICATION > ADDITIONAL DOCUMENTS > ATTACH FILE </li>"
        + "<li>or click Reply and email your address proof to <a href='mailto:kyc@rebit.co.nz'>kyc@rebit.co.nz</a></li>"
        + "</ul>"
        + "<p>Let us know if you have any questions or issues.</p>"
        + "<p>Kind regards,<br>Rebit Verification</p>"
}

